// TutorialNotification — the chassis of the COACHMARK family, one of the two
// CTA notification families DESIGN_LANGUAGE.md §7.6 defines. Coachmark chrome
// is `theme: 'canvas-card-glass'` + `round: 'radiusControl'`, elevation `float`
// carried by the theme (never a `shadow:` key here), and cookie dismissal.
//
// It is NOT the adoption target for the whole app. The elevated-alert family —
// CallInvitationBanner, CreditBlocker, AiActionConfirmCard, on
// `background:'document'` + `radiusSheet` + `shadow:'overlay'` with durable
// dismissal — stays separate on purpose. Nika decided that on 2026-08-29
// (CALLINVITATION-CONSOLIDATE-1, answer B): two families, each internally
// consistent, one per urgency tier. Giving this chassis an eyebrow slot, a
// header dismiss-X and an elevated-surface variant so those three could adopt
// it is the scope increase that decision declined — do not add them, and do
// not migrate those three here.
//
// `packages/shared/__tests__/notificationFamilyChrome.test.js` locks both
// signatures; move a member between families there and in §7.6, in the same
// commit, or not at all.
export const TutorialNotification = {
  extends: 'Navbar',
  theme: 'canvas-card-glass',
  padding: '0',
  overflow: 'hidden',
  align: 'stretch',
  transition: 'all, defaultBezier, B2',
  round: 'radiusControl',
  gap: 'A',
  flow: 'y',
  width: '100%',
  maxWidth: 'H2',
  rootSlide: true,
  useCookie: true,
  // Same cookie-dismiss contract as TutorialGifNotification (family
  // consistency — this card is the adoption target for canvas COACHMARK
  // notifications and must behave like every other dismissible card in
  // the family, not just look like one). Cookie dismissal is per-browser,
  // which is exactly why the elevated-alert family may never inherit it:
  // an urgent card dismissed on the laptop would return on the phone.
  if: (el, s) => {
    const preventByCookie = el.call('getCookie', 'tutorialMarked_' + s.key) === 'true'
    return el.useCookie ? !preventByCookie : true
  },
  state: {
    title: 'learn.coach.canvas.title',
    descr: 'learn.coach.canvasAlt.descr',
    icon: 'resize.json'
  },
  Lottie: {
    minWidth: '3.2em',
    src: '{{ icon }}',
    fontSize: 'C2'
  },
  Hgroup: {
    flex: 1,
    margin: 'auto',
    padding: 'Z B A',
    gap: 'Y1',
    lineHeight: 1.4,
    width: '100%',
    H: {
      tag: 'strong',
      text: (el, s) => el.call('polyglot', s.title || '')
    },
    P: {
      text: (el, s) => el.call('polyglot', s.descr || '')
    }
  },
  // Adopts the shared bottom action bar every other sibling uses (was a
  // bespoke absolute-positioned, icon-only right rail with no `onClick` on
  // either button — non-functional, and structurally too narrow to ever
  // hold a text-labeled 1-N CTA set). TutorialNotificationButtons already
  // supports N actions via its `children` array (see
  // TutorialGifNotificationSlider.js and gazer's OnboardingOverlay.js for
  // 2- and 3-button overrides) — this is the general contract callers
  // adopt: override `TutorialNotificationButtons.children` with
  // `{ icon, text, onClick, hide? }` objects.
  //
  // `order: '1'`: base keys merge BEFORE consumer keys, so a consumer's own
  // content key (Lead/Message) would otherwise land AFTER this action row —
  // in every horizontal pill the CTAs rendered LEFT of the message (measured
  // live on /infra, UI-TUTORIAL-NOTIFICATION-FAMILY-1). The action row is
  // the family's bottom/trailing bar by contract, so it pins itself last.
  TutorialNotificationButtons: { order: '1' }
}
